import { DetailSection } from '@periscopes/general';
import { Form } from 'antd';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { useForm } from 'antd/es/form/Form';
import { useTagReference } from '@hooks';
import { TagColorSection, TagDescriptionSection, TagNameSection, TagOwnersSection } from '@tags';
export const TagDetailsTab = ({ sonarObjectId }) => {
    const [form] = useForm();
    const tag = useTagReference(sonarObjectId);
    if (!tag.id) {
        return React.createElement(LoadingSpinner, { spinning: true });
    }
    return (React.createElement(Form, { form: form },
        React.createElement(DetailSection, null,
            React.createElement(TagColorSection, { tagId: sonarObjectId })),
        React.createElement(DetailSection, null,
            React.createElement(TagNameSection, { tagId: sonarObjectId })),
        React.createElement(DetailSection, null,
            React.createElement(TagOwnersSection, { tagId: sonarObjectId })),
        React.createElement(DetailSection, null,
            React.createElement(TagDescriptionSection, { tagId: sonarObjectId }))));
};
